import { CheckCircleRounded } from '@mui/icons-material';
import { CircularProgress, ListItemIcon, MenuItem, MenuList, Stack, Typography } from '@mui/material';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { ResponseObject } from '../common/common.entity';
import { useAppSelector } from '../store/hooks';
import { MuiStack } from './MuiStack';


export default function HorizontalTree(props: any) {
    const crud = useAppSelector(state => state.crud);
    const {
        getItems,
        apiKey,
        items = crud[apiKey]?.data,
        apiRequest,
        loading = crud['isLoading' + apiKey] === 'loading',
        onChange,
        valueSetter = (v: any) => v,
        ...others
    } = props
    const [selected, setSelected] = useState<ResponseObject>({});

    useEffect(() => {
        if (getItems) {
            getItems({ request: apiRequest });
        }
    }, [])

    const handleItemSelect = useCallback((e: any, value: any) => {
        if (!value?.children?.length) {
            let submitValues: any = [];

            setSelected((prev) => {
                let itemId = value?.id
                if (prev[itemId]) {
                    delete prev[itemId]
                } else {
                    prev[itemId] = value;
                }
                submitValues = valueSetter(Object.values(prev));
                return { ...prev };
            })

            if (onChange) onChange(e, submitValues)
        }
    }, [setSelected])

    return (
        <MuiStack justifyContent={loading ? 'center' : 'start'} alignItems={loading ? 'center' : 'initial'} height='50vh' p={1} borderRadius={2} bgcolor={'rgba(150,150,150,0.1)'} columnGap={1} overflow='auto' >
            {loading ? <CircularProgress /> :
                <>
                    <NestedList items={items} label='Modules' onChange={handleItemSelect} selectedItems={selected} />
                    <NestedList items={Object.values(selected)} label='Selected Items' onChange={handleItemSelect} selectedItems={selected} />
                </>
            }
        </MuiStack>
    )
}

const NestedList = (props: any) => {
    let { variant, items = [], getItemLabel = (item: any) => item['ChildName'], label = 'Tab', onChange = (e: any, v: any) => { }, selectedItems } = props
    if (variant === 'selectedItems') {
        items = Object.values(selectedItems);
        console.log(selectedItems);
    }

    const [current, setCurrent] = useState<string>('');
    const currentItem: ResponseObject | null = useMemo(() => items?.find((item: any) => item.id === current), [current, items])

    useEffect(() => {
        setCurrent('');
    }, [items])


    const handleChange = useCallback((e: any) => {
        const { id } = e.target
        if (!id) return;
        setCurrent(id === current ? '' : id)
        onChange(e, items?.find((item: any) => item?.id === id));
    }, [current, items])

    return items && (<>
        <Stack direction='column' maxHeight='100%'>
            <Typography px={2} py={0.5} color='#888' fontFamily='WorkSans-Medium' fontSize={14} >{label}</Typography>
            <MenuList
                onClick={handleChange}
                sx={{ minWidth: '200px', overflowY: 'auto', bgcolor: 'white', flexGrow: 1 }}
            >
                {
                    items?.map((item: any) => {
                        let checked: boolean = Boolean(item?.id === current || selectedItems[item?.id]);
                        return <MenuItem
                            id={item?.id}
                            selected={checked}
                            sx={{ color: checked ? '#111' : '#555', display: 'flex', justifyContent: 'space-between', columnGap: 1, textWrap: 'wrap' }}
                        >
                            {item.label}
                            <ListItemIcon >
                                {selectedItems[item?.id] ? <CheckCircleRounded fontSize='small' htmlColor='#666' /> : null}
                            </ListItemIcon>
                        </MenuItem>
                    })
                }
            </MenuList>
        </Stack>
        {currentItem?.children?.length ? <NestedList items={currentItem?.children} label={getItemLabel(currentItem)} onChange={onChange} selectedItems={selectedItems} /> : null}
    </>
    )
}
